import React, { useState, useEffect } from 'react';
import "./attachment-card.scss";

const AttachmentCard = (props:any) => {

  const supportedImgTypes = ["GIF", "TIFF", "JPG", "PNG"];
  // const supportedOtherTypes = ["DOC", "DOCX", "PDF"];
  const [viewerActive, setViewerActive] = useState(false);
  const [fileURL, setFileURL] = useState("");

  const handleImgClick = () => {
    setViewerActive(true);
  }

  const deleteAttachment = (relContentId, attchId) => {
    // alert("ELIMINAR ADJUNTO => relContentId: " + relContentId + " attchId: " + attchId);
  }

  useEffect(() => {
    if (!!props.fileUrl) {
      setFileURL(props.fileUrl);
    }
    if (!!props.file) {
      const getBase64URL = async() => {
        const reader = new FileReader();
        const readFile = async (oFile) => {
          return new Promise<string>((resolve, reject) => {
            reader.readAsDataURL(oFile);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
          });
        }
        await readFile(props.file).then((result) => setFileURL(result));
      }
      getBase64URL();
    }
  }, []);

  useEffect(() => {
      document.body.style.overflow = viewerActive ? "hidden" : "unset";
  }, [viewerActive]);

  const RenderedCmp = () => {
    if (supportedImgTypes.includes(props.fileType.toUpperCase())) {
      return (
        <>
          <div className="m-attachment-img">
            <button onClick={()=> handleImgClick()}>
            <svg xmlns="http://www.w3.org/2000/svg" width="33.534" height="33.534" viewBox="0 0 33.534 33.534">
              <defs>
                <filter id="flecha-arriba-derecha-y-flecha-abajo-izquierda-desde-el-centro" x="0" y="0" width="33.534" height="33.534" filterUnits="userSpaceOnUse">
                  <feOffset dy="3" input="SourceAlpha"/>
                  <feGaussianBlur stdDeviation="3" result="blur"/>
                  <feFlood flood-opacity="0.161"/>
                  <feComposite operator="in" in2="blur"/>
                  <feComposite in="SourceGraphic"/>
                </filter>
              </defs>
              <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#flecha-arriba-derecha-y-flecha-abajo-izquierda-desde-el-centro)">
                <path id="flecha-arriba-derecha-y-flecha-abajo-izquierda-desde-el-centro-2" data-name="flecha-arriba-derecha-y-flecha-abajo-izquierda-desde-el-centro" d="M7.159,9.748,3.315,13.592H5.826v1.942H1.618A1.62,1.62,0,0,1,0,13.916V9.709H1.942V12.22L5.786,8.376,7.159,9.748ZM13.916,0H9.709V1.942H12.22L8.376,5.786,9.748,7.159l3.844-3.844V5.825h1.942V1.618A1.62,1.62,0,0,0,13.916,0Z" transform="translate(9 6)" fill="#fff"/>
              </g>
            </svg>

            </button>
            <img src={fileURL}/>
          </div>
          <div className={`m-attachment-large ${viewerActive ? "" : "hidden"}`}>
            <div className="m-attachment-large__backdrop">
              <div className="img-box">
                <button type="button" className="btn-close-viewer" onClick={()=>{setViewerActive(false)}}></button>
                <img src={fileURL}/>
              </div>
            </div>
          </div>
        </>
      );
    }
    else {
      return  (
        <a href={props.fileUrl} className={`m-attachment-card-anchor ${props.fileUrl ? "" : "disabled"}`} target={props.fileUrl ? "" : "_blank"}>
          <div className="m-attachment-other">
              <div className="m-attachment-other-download">
                <i className="icon-download"></i>
              </div>
              <div className="m-attachment-other-separator">
                <hr/>
              </div>
              <div className="m-attachment-other-desc">
                <div className="m-attachment-other-desc-type">
                  {props.fileType.toUpperCase()}
                </div>
                <div className="m-attachment-other-desc-name">
                  {props.fileName}
                </div>
              </div>
          </div>
        </a>
      );
    }
  }

  return (
      <>
        <div className="m-attachment-card">
          <button type="button" className={`btn-del-attch ${props.editMode ? "" : "hidden"}`} onClick={()=>{deleteAttachment(props.idComentario, props.idAttachment)}}>
            <i className="icon-trash-alt1"/>
          </button>
          <RenderedCmp/>
        </div>
      </>
  );

}

export default AttachmentCard;